// extracted by mini-css-extract-plugin
module.exports = {"block":"recovery_block__2PQqD","groupButtons":"recovery_groupButtons__1CqdU","buttonCancel":"recovery_buttonCancel__2YaEv"};